<div ngbDropdown *ngIf="afdeling$ | async as afdelinger">
    <button class="btn btn-primary btn-sm btn--menu ms-2" id="groupSelect" ngbDropdownToggle>Afdeling: {{selectedAfdeling || 'Alle'}}</button>
    <div ngbDropdownMenu aria-labelledby="groupSelect">
        <button (click)="onSelectAfdeling(null)" class="dropdown-item">Alle</button>
        <button *ngFor="let afdeling of afdelinger" (click)="onSelectAfdeling(afdeling)" class="dropdown-item">{{afdeling.afdelingsnavn}}</button>
    </div>
</div>
